<template>
    <div>
        <p-card>
            <p-search-table
                api-destination="nonmerch"
                ref="searchTable"
                edit-key="specialItemId"
                sort-by="name"
                :filters="filters"
                :fields="fields"
                :per-page="100"
                :enable-row-selection="false"
                empty-text="No active non-merch items found.">
                <template v-slot:head(included)>
                    Allow <span class="ps-1">({{ includedSpecialItemIds.length }})</span>
                </template>

                <template v-slot:cell(included)="{ item }">
                    <p-checkbox
                        inline
                        :model-value="isIncluded(item)"
                        @change="toggleIncluded(item)" />
                </template>
            </p-search-table>
        </p-card>
    </div>
</template>

<script>
import { currencyFormatter } from '../../components/Common/Formatters.js';

export default {
    props: {
        account: Object,
        // Special item ids already in AccountNonMerch for this account. Mutated in
        // place so the parent's NavigationGuard watcher sees the change and the
        // ids ride along on the account's existing save.
        includedSpecialItemIds: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        isIncluded(nonMerchItem) {
            return this.includedSpecialItemIds.includes(nonMerchItem.specialItemId);
        },
        toggleIncluded(nonMerchItem) {
            const existingIndex = this.includedSpecialItemIds.indexOf(nonMerchItem.specialItemId);
            if (existingIndex > -1) {
                this.includedSpecialItemIds.splice(existingIndex, 1);
                return;
            }
            this.includedSpecialItemIds.push(nonMerchItem.specialItemId);
        }
    },
    data() {
        return {
            filterName: 'AccountNonMerchFilter',
            filters: {
                automatic: '',
                searchBy: 'All',
                options: ['All'],
                isActiveFilter: true,
                perPage: 100
            },
            fields: [
                {
                    key: 'included',
                    label: 'Allow',
                    sortable: false,
                    thClass: 'text-center',
                    tdClass: 'text-center',
                    thStyle: { width: '100px' }
                },
                {
                    key: 'name',
                    label: 'Name',
                    sortable: true
                },
                {
                    key: 'location',
                    label: 'Location',
                    sortable: true
                },
                {
                    key: 'tax',
                    label: 'Tax',
                    sortable: true
                },
                {
                    key: 'price',
                    label: 'Price',
                    sortable: true,
                    formatter: (value) => currencyFormatter(value, 'Variable')
                },
                {
                    key: 'allowDiscounts',
                    label: 'Allow Discounts',
                    sortable: true
                },
                {
                    key: 'isRefundable',
                    label: 'Is Refundable',
                    sortable: true
                },
                {
                    key: 'specialItemId',
                    hidden: true
                }
            ]
        };
    }
};
</script>

<style scoped lang="scss">
    :deep(.p-checkbox-wrapper) {
        margin-right: 0;
    }
</style>
